import $ from 'jquery';
import {ReactElement, useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import './CookiePanel.css';

enum AllowCookie {
    ALLOW_ALL = 'ALLOW_ALL',
    ALLOW_NESSESARY = 'ALLOW_NESSESARY',
    NOT_CHOSEN = 'NOT_CHOSEN',
}

const ALLOW_COOKIE_KEY = 'ALLOW_COOKIE_KEY';

export const useAllowSite = () => {
    const [searchParams] = useSearchParams();
    const resetCookie = searchParams.get('resetCookie');
    return (): boolean => {
        return (
            localStorage.getItem(ALLOW_COOKIE_KEY) === AllowCookie.ALLOW_ALL &&
            resetCookie !== 'true'
        );
    };
};
export const CookiePanel = () => {
    const [searchParams] = useSearchParams();
    const allowCookie = localStorage.getItem(ALLOW_COOKIE_KEY);
    const [allowCookieChosen, setAllowCookieChosen] = useState<string | null>(
        allowCookie
    );
    const [result, setResult] = useState<ReactElement<any, any>>(<></>);
    const resetCookie = searchParams.get('resetCookie');

    const doAllowCookies = () => {
        localStorage.setItem(ALLOW_COOKIE_KEY, AllowCookie.ALLOW_ALL);
        setAllowCookieChosen(AllowCookie.ALLOW_ALL);
    };
    if (resetCookie === 'true') {
        localStorage.setItem(ALLOW_COOKIE_KEY, AllowCookie.NOT_CHOSEN);
        console.log(
            'Reset cookie key ' +
            ALLOW_COOKIE_KEY +
            ' To value ' +
            AllowCookie.NOT_CHOSEN
        );
    }
    const displayValue = $('#cookie-wrapper').css('display');
    if (displayValue === 'none') {
        console.log(
            "A I don't care about cookies extension has been used. This means cookies have been accepted"
        );
        doAllowCookies();
    }
    console.log('cookie display value: ' + displayValue);
    const showCookieBox = (
        <div className='cookie-wrapper' id='cookie-wrapper' key='cookie-panel'>
            <div className='cookie panel' id='cookie-panel'>
                <div className='cookie-text' id='cookie-text'>
                    <h2>Your data</h2>
                    <p>I collect web site statistics using 3rd party libraries.</p>
                    <p>
                        I store local cookies and data if it enhances the user experience.
                    </p>
                    <p>I do NOT sell any data collected.</p>
                </div>
                <div className='cookie-buttons' id='cookie-buttons'>
                    <button
                        id='accept-all-cookies'
                        onClick={() => {
                            doAllowCookies();
                        }}
                    >
                        I understand - Accept all cookies
                    </button>
                </div>
            </div>
        </div>
    );

    const onAllowCookieChosen = () => {
        if (allowCookie === null || allowCookie === AllowCookie.NOT_CHOSEN) {
            console.log('Cookie is null or not chosen. Show cookie panel');
            setResult(showCookieBox);
        } else {
            console.log('Remove cookie panel and reload');
            setResult(<></>);
            // window.location.reload();
        }
    };
    useEffect(() => {
        onAllowCookieChosen();
        // eslint-disable-next-line
    }, [allowCookieChosen]);

    return <>{result}</>;
};
